var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "#FEE2B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5284 18.8924L13.5299 18.8939C13.76 19.1147 13.875 19.3884 13.875 19.7239C13.875 20.0591 13.7602 20.3326 13.5306 20.5533C13.3061 20.7611 12.9673 20.875 12.4932 20.875C12.0196 20.875 11.681 20.7614 11.4565 20.554C11.236 20.3338 11.125 20.0601 11.125 19.7239C11.125 19.387 11.2365 19.1128 11.458 18.8923C11.6827 18.6695 12.0206 18.5483 12.4932 18.5483C12.9658 18.5483 13.3037 18.6696 13.5284 18.8924ZM11.3974 16.6971L11.2274 3.50483C11.2247 3.29585 11.3934 3.125 11.6024 3.125H13.2464C13.4556 3.125 13.6243 3.29608 13.6214 3.5052L13.4384 16.6971H11.3974Z",
    fill: "#E05E22",
    stroke: "#FDAC42",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5616 16.8221H10.274L10.1024 3.50644C10.0988 3.2278 10.3237 3 10.6024 3H12.2464C12.5253 3 12.7503 3.22811 12.7464 3.50694L12.5616 16.8221ZM10 19.7239C10 19.3558 10.1233 19.0491 10.3699 18.8037C10.6256 18.5501 11 18.4233 11.4932 18.4233C11.9863 18.4233 12.3607 18.5501 12.6164 18.8037C12.8721 19.0491 13 19.3558 13 19.7239C13 20.092 12.8721 20.3988 12.6164 20.6442C12.3607 20.8814 11.9863 21 11.4932 21C11 21 10.6256 20.8814 10.3699 20.6442C10.1233 20.3988 10 20.092 10 19.7239Z",
    fill: "#FDAC42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5616 16.8221H10.274L10.1024 3.50644C10.0988 3.2278 10.3237 3 10.6024 3H12.2464C12.5253 3 12.7503 3.22811 12.7464 3.50694L12.5616 16.8221ZM10 19.7239C10 19.3558 10.1233 19.0491 10.3699 18.8037C10.6256 18.5501 11 18.4233 11.4932 18.4233C11.9863 18.4233 12.3607 18.5501 12.6164 18.8037C12.8721 19.0491 13 19.3558 13 19.7239C13 20.092 12.8721 20.3988 12.6164 20.6442C12.3607 20.8814 11.9863 21 11.4932 21C11 21 10.6256 20.8814 10.3699 20.6442C10.1233 20.3988 10 20.092 10 19.7239Z",
    fill: "#FDAC42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.0629H20.0806V12.7887H15V12.0629Z",
    fill: "#051029"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3805 9.07932L18.4598 6.00004L18.973 6.51325L15.8937 9.59253L15.3805 9.07932Z",
    fill: "#051029"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3805 15.2224L15.8937 14.7092L18.973 17.7885L18.4598 18.3017L15.3805 15.2224Z",
    fill: "#051029"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.0629H3.92V12.7887H9V12.0629Z",
    fill: "#051029"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61951 9.07935L5.54059 6.00007L5.02744 6.51328L8.10635 9.59256L8.61951 9.07935Z",
    fill: "#051029"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61951 15.2224L8.10635 14.7092L5.02744 17.7885L5.54059 18.3017L8.61951 15.2224Z",
    fill: "#051029"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/infoWarning.865dc8b5b5772b05d248d8a03eb4eb87.svg";